import React from "react";
import Cookies from 'universal-cookie';

const SSRStorage = {
    getItem: (key) => {
        const cookies = new Cookies();
        if (!ssr) {

            return localStorage.getItem(String(key)) || cookies.get(String(key))
        }
        return localMemory[key] || cookies.get(String(key))
    },
    setItem:  (key, value) => {
        const cookies = new Cookies();
        if (!ssr) {

            cookies.set(String(key), value, { path: '/' });
            localStorage.setItem(String(key), value)
        }
        cookies.set(String(key), value, { path: '/' });
        localMemory[String(key)] = value
    },
    removeItem: (key) => {
        const cookies = new Cookies();
        if (!ssr) {

            cookies.remove(String(key))
            localStorage.removeItem(String(key))
        }
        cookies.remove(String(key))
        delete localMemory[String(key)]
    },

};

export default SSRStorage;
//
// const SSRStorage = {
//     getItem: async (key) => {
//         console.log('1')
//         if (!ssr) {
//             return localStorage.getItem(key.toString())
//         }
//         let result = undefined;
//         console.log('2')
//         await fetch(route("cookie.get"), {
//             method: "POST",
//             body: JSON.stringify({
//                 key: key.toString()
//             }),
//             headers: {
//                 "Content-Type": "application/json",
//                 Accept: "application/json"
//             }
//         }).then((res) => res.json()).then((response) => {
//             console.log('3')
//             console.log(response.result)
//             return response.result === null ? undefined : response.result
//         }).catch((error) => {
//             console.log('4')
//             return undefined;
//         });
//         console.log('5')
//         return result;
//     },
//     setItem: async (key, value) => {
//         if (!ssr) {
//             localStorage.setItem(key.toString(), value)
//         } else {
//             await fetch(route("cookie.set"), {
//                 method: "POST",
//                 body: JSON.stringify({
//                     key: key.toString(),
//                     value: value,
//                 }),
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json"
//                 }
//             }).then((res) => res.json()).then((response) => {
//                 //
//             }).catch((error) => {
//                 //
//             });
//         }
//     },
//     removeItem: async (key) => {
//         if (!ssr) {
//             localStorage.removeItem(key.toString())
//         } else {
//             await fetch(route("cookie.remove"), {
//                 method: "POST",
//                 body: JSON.stringify({
//                     key: key.toString()
//                 }),
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json"
//                 }
//             }).then((res) => res.json()).then((response) => {
//                 //
//             }).catch((error) => {
//                 //
//             });
//         }
//     },
//
// };